module.exports = __webpack_public_path__ + "static/img/dht11-1.2168a9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/dht11-1.svg
// module id = eVeh
// module chunks = 0